
import React from "react";

function About() {
  return (
    <div
      style={{
        backgroundColor: "#31282828",
        minHeight: "100vh",
        padding: "40px 0",
        color: "#ffffff",
        borderLeft: "150px solid  #0C2B4B",
        borderRight: "150px solid #0C2B4B",
      }}
    >
      <div className="container py-5">

        {/* 🔹 Top Image */}
        <div className="mb-4">
          <img
            src="/assets/img/tech.png "    // Make sure this image exists in public/img
            alt="About Us"
            className="img-fluid rounded"
            style={{ width: "100%", height: "400px", objectFit: "cover" }}
          />
        </div>

        {/* 🔹 Text Below */}
        <div>
          <div style={{ fontSize: "20px", lineHeight: "1.8" }}>

            <h1 style={{ fontSize: "30px", 
              marginBottom: "20px"
               }}>
              <u><b>About Us</b></u>
            </h1>
            
          <ul>
            <li>
              We are a technology-focused platform dedicated to building structured digital management systems for institutions and communities.
            </li>
            <li>
              Our solutions are designed to simplify administration, improve transparency, and automate financial and operational workflows.
            </li>
          </ul>
          <br />

          <h1 style={{ fontSize: "20px", marginBottom: "20px" }}><b><u>Our Mission</u></b></h1>
          <ul>
            <li>
              Our mission is to empower organizations with reliable, secure, and scalable digital tools that reduce manual effort and enhance accountability.            </li>
            <li>
              We believe administration should be organized, efficient, and data-driven.
            </li>
          </ul>
          <br />

          <h1 style={{ fontSize: "20px", marginBottom: "20px" }}><b><u>What We Do</u></b></h1>
          <ul>
            <p><b>
              We develop comprehensive management platforms tailored for:
            </b></p>
            <li>Residential Housing Societies. </li>
            <li>Schools & Educational Institutions.</li><br />
            <p><b>Our systems streamline:</b></p>
            <li>Billing & fee management.</li>
            <li>Online & offline payment tracking.</li>
            <li>Communication & notices.</li>
            <li>Member / student management.</li>
            <li>Reporting & financial transparency</li>
          </ul>
          <br />

          <h1 style={{ fontSize: "20px", marginBottom: "20px" }}><b>Our Commitment</b></h1>
            <ul>
              <p><b>We are committed to:</b></p>
              <li>Data security.</li>
              <li>Structured accounting.</li>
              <li>Continuous improvement.</li>
              <li>Long-term reliability.</li>
              <li>Practical, real-world solutions.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;